export default __webpack_public_path__ + "icon-social-media-linkedin-rollover.4e0034e5441b6c622d57.svg";